import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Home from "../../../../src/common/assets/data/home/index";
import Container from "../ui-components/container";

function Navbar() {
  const data = Home.Navbar;
  const [navbar, setNavbar] = useState(false);
  const [toggle, settoggle] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 300) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });
  const closeFunction =()=>{
    settoggle(false);
  }
 
  return (
    <header
      className={`${
        navbar ? "bg-white sticky top-0" : "bg-primary "
      } shadow-lg z-50 `}
    >
      <Container>
        <nav className="py-4">
          <div className="flex flex-wrap justify-between items-center mx-auto relative ">
            <Link to="/" className="flex items-center ">
              <div className="absolute top-[0px] bg-white   rounded-full w-[75px] h-[75px] md:w-[95px] md:h-[95px]">
                <img
                  src={navbar ? data.logo.dark_logo : data.logo.light_logo}
                  className="p-3  rounded-full"
                  alt="Vaidyo Logo"
                />
              </div>
            </Link>
            <div className="flex items-center lg:order-2">
              <Link
                to="https://vaidyo.in/Finsol/"
                target="_blank"
                className={`${
                  navbar
                    ? "text-primary border-primary"
                    : "text-white border-white"
                } py-2 px-4 rounded font-bold border border-solid invisible lg:visible  `}
              >
                Login
              </Link>
              <div className="lg:hidden">
                <button
                  className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                  onClick={() => settoggle(!toggle)}
                >
                  {toggle ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  )}
                </button>
              </div>
              {/* <button
                data-collapse-toggle="mobile-menu-2"
                type="button"
                className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                aria-controls="mobile-menu-2"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  
                >
                  <path
                    fill-rule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <svg
                  className="hidden w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button> */}
            </div>

            <div
              className={`justify-between items-center w-full lg:flex lg:w-auto lg:order-1 ${
                toggle ? "block" : "hidden"
              }`}
              // className="justify-between items-center w-full lg:flex lg:w-auto lg:order-1"
              id="mobile-menu-2"
            >
              <ul className="flex flex-col text-center  mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0" id="closeData">
                {data.menu_items.map((link) => (
                  <li id={link.id}  >
                    <Link
                      to={link.path}
                      className={`block py-2 pr-4 pl-3 round ${
                        navbar ? "text-primary" : "text-white"
                      }  sm:p-0 ${link.subMenu ? "menu-dropdown " : ""}`}
                      aria-current="page"
                    >
                      {link.id ==  3 ? ( <span >{link.label}</span>):(
                         <span onClick={closeFunction}>{link.label}</span>
                      )} 
                      {/* <span onClick={closeFunction}>{link.label}</span> */}
                      {link.subMenu && (
                        <ul className="dropdown-content text-black">
                          {link.subMenu.map((subLink) => (
                          
                            <li className="py-2 px-3" onClick={closeFunction} >
                              <Link
                                to={subLink.path}
                                className={`block py-2 pr-4 pl-3 round lg:p-0`}
                                aria-current="page"
                              >
                                <span>{subLink.label}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </nav>
      </Container>
    </header>
  );
}

export default Navbar;
